// import React, { useEffect, useState } from "react";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link } from "react-router-dom";
// import PaginationComponent from "../../../Components/PaginationComponent";
// import toast from 'react-hot-toast';
// import expenseService from "../../../Services/expenseService";

// const Expense = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [patients, setPatients] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [startDate, setStartDate] = useState("");
//     const [endDate, setEndDate] = useState("");

//   // useEffect(() => {
//   //   const getPatients = async () => {
//   //     try {
//   //       setLoading(true);
//   //       const response = await expenseService.fetchAll();
//   //       console.log(response);
//   //       setPatients(response.expenses);
//   //       setLoading(false);
//   //     } catch (error) {
//   //       setLoading(false);
//   //       toast.error('Error fetching Patients');
//   //     }
//   //   };
//   //   getPatients();
//   // }, []);

//   useEffect(() => {
//     const getPatients = async () => {
//       try {
//         setLoading(true);
//         const response = await expenseService.fetchAll();
//         console.log(response);
  
//         // Sort the expenses by 'expense_date' in ascending order
//         const sortedExpenses = response.expenses.sort((a, b) => {
//           const dateA = new Date(a.expense_date);
//           const dateB = new Date(b.expense_date);
//           return dateB - dateA; // Sort in ascending order
//         });
  
//         setPatients(sortedExpenses);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error('Error fetching Patients');
//       }
//     };
  
//     getPatients();
//   }, []);
  

//   // useEffect(() => {
//   //   const filteredResult = patients?.filter(
//   //     (item) =>
//   //       item?.item_name?.toLowerCase().includes(searchData.toLowerCase())
//   //   ) || [];
//   //   setFilteredData(filteredResult);
//   //   setCurrentPage(1);
//   // }, [searchData, patients]);

//   useEffect(() => {
//       const filteredResult =
//         patients?.filter((item) => {
//           const itemDate = new Date(item?.expense_date);
//           const isWithinDateRange =
//             (!startDate || new Date(startDate) <= itemDate) &&
//             (!endDate || itemDate <= new Date(endDate));
//           return (
//             item?.item_name?.toLowerCase().includes(searchData.toLowerCase()) &&
//             isWithinDateRange
//           );
//         }) || [];
//       setFilteredData(filteredResult);
//       setCurrentPage(1);
//     }, [searchData, startDate, endDate, patients]);





//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const formatDate = (dateString) => {
//     if (!dateString) return ''; // Handle null or undefined
//     const options = { year: 'numeric', month: 'short', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString('en-US', options);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[24px] text-gray-700 font-[700]">Manage Expenses</h1>
//         <h1 className="ml-[3%] text-[9px] bg-[#F07F1B] py-[3px] text-center rounded-full w-24 text-white font-bold">{filteredData?.length || 0} records found</h1>
        
//         <div className="flex mt-8 flex-row-reverse justify-between mx-[3%]">
//           <div className="space-x-4">
//           <Link to='AddEditExpense'>
//             <button className="bg-white text-[#F07F1B] font-semibold border hover:bg-[#F07F1B] hover:text-white py-2 px-8 rounded-full duration-300">
//               + 
//             </button>
//           </Link>
//           <Link to='AddEditExpenseHead'>
//             <button className="bg-white text-[#F07F1B] font-semibold border hover:bg-[#F07F1B] hover:text-white py-2 px-8 rounded-full duration-300">
//               Add Expense Account Head
//             </button>
//           </Link>
//           </div>
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>
//         </div>

//         <div className="ml-[3%] space-x-4 mb-4">
//             <input
//               type="date"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//               className="bg-white text-black font-medium border py-2 px-4 rounded-full duration-300"
//               placeholder="Start Date"
//             />
//             <input
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               className="bg-white text-black font-medium border py-2 px-4 rounded-full duration-300"
//               placeholder="End Date"
//             />
//             <button
//               onClick={() => {
//                 setStartDate("");
//                 setEndDate("");
//               }}
//               className="bg-white text-[#F07F1B] font-semibold border hover:bg-[#F07F1B] hover:text-white py-2 px-8 rounded-full duration-300"
//             >
//               Show All
//             </button>
//           </div>

//         <div className="mx-[3%] rounded-lg">
//           <table className="w-[100%] rounded-lg overflow-hidden">
//             <thead className="bg-gray-700">
//               <tr className="text-white text-left text-[12px] capitalize leading-normal">
//                 <th className="py-4 w-[20%] pl-4">Date</th>
//                 <th className="py-4 w-[30%]">Amount</th>
                
//                 <th className="py-4 w-[30%]">Details</th>
//                 <th className="py-4 w-[20%]">Expense Account</th>
             
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((patient) => (
//                 <tr key={patient?.patient_id} className="bg-white text-gray-600 text-xs font-light border-t-[1px] border-gray-200">
                  
//                   <td className="w-[20%] text-left">
//                     <p className="font-[600] text-gray-600 pl-4">{formatDate(patient?.expense_date)}</p>
//                   </td>
//                   <td className="py-4 w-[30%] text-left">
//                     <p className="font-[600] text-gray-600">{patient?.amount}</p>
//                     <p className="font-[400] text-gray-500">{patient?.item_name}</p>
//                   </td>
                  
//                   <td className="py-4 w-[30%] text-left">
//                     <span className="font-[400]">{patient?.description}</span>
//                   </td>

//                   <td className="py-4 w-[20%] text-left">
//                     <span className="font-[400]">{patient?.expensehead_title}</span>
//                   </td>
                
//                   {/* <td className="py-[2%] w-[10%] text-center">
//                     <Link to={`/patient/patients/${patient.patient_id}`}>
//                       <button className="text-[13px] font-[500] text-blue-500">View</button>
//                     </Link>
//                   </td> */}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <PaginationComponent
//           filteredData={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />
//       </div>
//     </div>
//   );
// };

// export default Expense;


import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import expenseService from "../../../Services/expenseService";

const Expense = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const getPatients = async () => {
      try {
        setLoading(true);
        const response = await expenseService.fetchAll();
        const sortedExpenses = response.expenses.sort(
          (a, b) => new Date(b.expense_date) - new Date(a.expense_date)
        );
        setPatients(sortedExpenses);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching Expenses");
      }
    };
    getPatients();
  }, []);

  useEffect(() => {
    const filteredResult =
      patients?.filter((item) => {
        const itemDate = new Date(item?.expense_date);
        const isWithinDateRange =
          (!startDate || new Date(startDate) <= itemDate) &&
          (!endDate || itemDate <= new Date(endDate));
        return (
          item?.item_name?.toLowerCase().includes(searchData.toLowerCase()) &&
          isWithinDateRange
        );
      }) || [];
    setFilteredData(filteredResult);
    setCurrentPage(1);
  }, [searchData, startDate, endDate, patients]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
  }, [currentPage, filteredData]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const totalAmount = filteredData
    .reduce((sum, item) => sum + parseFloat(item?.amount || 0), 0)
    .toFixed(2);

  return (
    <div className="p-6">
      {/* HEADER */}
      <div className="flex items-center justify-between bg-white border border-gray-200 rounded-xl px-6 py-4 mb-5 shadow-sm">
        <div>
          <h1 className="text-[17px] font-[500] text-gray-800">Manage Expenses</h1>
          <p className="text-[12px] text-gray-400 mt-0.5">
            {filteredData?.length || 0} records found
          </p>
        </div>

        <div className="flex items-center gap-3">
          {/* Start Date */}
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px] focus:outline-none text-gray-700"
          />

          {/* End Date */}
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px] focus:outline-none text-gray-700"
          />

          {/* Show All */}
          {(startDate || endDate) && (
            <button
              onClick={() => { setStartDate(""); setEndDate(""); }}
              className="text-[13px] bg-gray-100 hover:bg-gray-200 text-gray-600 px-4 py-[7px] rounded-lg"
            >
              Show All
            </button>
          )}

          {/* Search */}
          <div className="relative">
            <SearchIcon
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              style={{ fontSize: 16 }}
            />
            <input
              type="search"
              placeholder="Search by item..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              className="pl-8 pr-3 py-[7px] w-[200px] text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none"
            />
          </div>

          {/* Add Expense Head */}
          <Link to="AddEditExpenseHead">
            <button              className="relative overflow-hidden bg-gray-800 text-white text-[13px] font-[500] px-4 py-2 rounded-lg border border-gray-300 shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 before:absolute before:inset-0 before:-translate-x-full hover:before:translate-x-full before:bg-white/20 before:transition-transform before:duration-500"               
>
              + Expense Head
            </button>
          </Link>

          {/* Add Expense */}
          <Link to="AddEditExpense">
            <button              className="relative overflow-hidden bg-gray-800 text-white text-[13px] font-[500] px-4 py-2 rounded-lg border border-gray-300 shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 before:absolute before:inset-0 before:-translate-x-full hover:before:translate-x-full before:bg-white/20 before:transition-transform before:duration-500"               
>
              + New Expense
            </button>
          </Link>
        </div>
      </div>

      {/* TABLE */}
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-800 text-[11px] uppercase text-white">
              <th className="py-3 px-4 text-left">Date</th>
              <th className="py-3 px-4 text-left">Item Name</th>
              <th className="py-3 px-4 text-left">Amount</th>
              <th className="py-3 px-4 text-left">Details</th>
              <th className="py-3 px-4 text-left">Expense Account</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="py-10 text-center text-gray-400 text-[13px]">
                  Loading...
                </td>
              </tr>
            ) : paginatedData?.length === 0 ? (
              <tr>
                <td colSpan={5} className="py-10 text-center text-gray-400 text-[13px]">
                  No records found
                </td>
              </tr>
            ) : (
              <>
                {paginatedData?.map((patient, index) => (
                  <tr
                    key={patient?.expense_id || index}
                    className={`border-t text-[13px] hover:bg-gray-50 ${
                      index % 2 === 0 ? "bg-gray-50" : "bg-white"
                    }`}
                  >
                    <td className="py-3 px-4 font-[500] text-gray-800">
                      {formatDate(patient?.expense_date)}
                    </td>
                    <td className="py-3 px-4 text-gray-600">
                      {patient?.item_name}
                    </td>
                    <td className="py-3 px-4 font-semibold text-gray-800">
                      {parseFloat(patient?.amount || 0).toFixed(2)}
                    </td>
                    <td className="py-3 px-4 text-gray-500">
                      {patient?.description || "-"}
                    </td>
                    <td className="py-3 px-4 text-gray-600">
                      {patient?.expensehead_title || "-"}
                    </td>
                  </tr>
                ))}

                {/* Total Row */}
                <tr className="bg-gray-800 text-white text-[13px] font-semibold">
                  <td className="py-3 px-4" colSpan={2}>Total</td>
                  <td className="py-3 px-4">{totalAmount}</td>
                  <td colSpan={2}></td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default Expense;